import translations from './translations'

translations.add('is', {
    invalidCvv: 'Vinsamlegast sláðu inn gildan öryggiskóða',
    pleaseEnter: 'Vinsamlegast sláðu inn:',
    backCardList: 'Aftur í kortalistann'
})
